module.exports = __webpack_public_path__ + "static/media/reference-slider-19.19f398c5.jpg";